import { render, staticRenderFns } from "./SAccUsersList.vue?vue&type=template&id=0dafdb8b&scoped=true"
import script from "./SAccUsersList.vue?vue&type=script&lang=ts"
export * from "./SAccUsersList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dafdb8b",
  null
  
)

export default component.exports